<template>
    <transition name="fade">
        <div class="container">
            <div class="league-create-link-wrapper">
                <i class="white-medal-ico icon-white-medal"></i>
                <h2 class="league-create-link">
                    <Loading :loadingState="nameLoadingState">{{localGroupName}}</Loading>
                </h2>
                <p class="league-create-link-p">
                Jedinstveni link za tvoju grupu je:
                </p>
                <a :href="joinGroupUrl" class="unique-league-link">
                {{ joinGroupUrl }}
                </a>
                <ul class="socials" v-if="false">
                    <li><a href="#" class="face icon-face" ></a></li>
                    <li><a href="#" class="wapp icon-wapp" ></a></li>
                    <li><a href="#" class="viber icon-viber" ></a></li>
                    <li><a href="#" class="blank icon-chain" ></a></li>
                    <li><a href="#" class="blank icon-mail-3" ></a></li>
                </ul>
            </div>
            <a href="#" @click.prevent="deleteUserGroup()" class="button-1 red">
                <span>Obriši svoju grupu</span>
            </a>
        </div>
    </transition>
</template>

<script>
import Loading from '../common/Loading'
import LoadingState from '../../utils/loading/LoadingState'
import { getPublicPath } from '../../utils/getPublicPath'

export default {
    name: 'kreirajgrouplink',
    data () {
        return {
            nameLoadingState: LoadingState.Loading,
            localGroupName: null,
            deletingUserGroup: false
        }
    },
    props: {
        groupId: null,
        groupName: null
    },
    components: {
        Loading
    },
    async mounted () {
        if (!this.groupNameProp) {
            try {
                this.localGroupName = await this.$db.grupe.getGroupName(this.groupId)
                this.nameLoadingState = LoadingState.SUCCESS
            } catch (error) {
                this.nameLoadingState = LoadingState.ERROR
            }
        } else {
            this.nameLoadingState = LoadingState.SUCCESS
        }
    },
    methods: {
        async deleteUserGroup () {
            if (!this.deletingUserGroup) {
                this.deletingUserGroup = true
                try {
                    let data = await this.$db.grupe.deleteUserGrupa({ groupId: this.groupId })
                    if (data.success) {
                        this.$emit('deleted', true)
                    }
                } catch (error) {
                    console.error(error)
                }
                this.deletingUserGroup = false
            }
        }
    },
    watch: {
        groupName (after) {
            if (after) {
                this.localGroupName = after
            }
        }
    },
    computed: {
        currentUrl () {
            var protocol = location.protocol
            var slashes = protocol.concat('//')
            var host = slashes.concat(window.location.host)
            return host
        },
        joinGroupUrl () {
            let publicPath = getPublicPath()
            return `${this.currentUrl}${publicPath}/grupa/${this.groupId}`
        },
        groupNameProp () {
            if (this.groupName) {
                return this.groupName
            } else {
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.unique-league-link {
    transition: color .4s ease-in-out;

    &:hover  {
        color: #0a2c4d;
    }
}
</style>
